var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 0.25H1.33333C0.73425 0.25 0.25 0.73425 0.25 1.33333V4.13917C0.25 4.70575 0.48075 5.26258 0.881584 5.66342L6.75 11.5318V19.75C6.75 20.1259 6.945 20.4737 7.26458 20.6719C7.43792 20.7792 7.63508 20.8333 7.83333 20.8333C7.99908 20.8333 8.16483 20.7954 8.31758 20.7196L12.6509 18.5529C13.0182 18.3688 13.25 17.9939 13.25 17.5833V11.5318L19.1184 5.66342C19.5193 5.26258 19.75 4.70575 19.75 4.13917V1.33333C19.75 0.73425 19.2658 0.25 18.6667 0.25ZM11.4008 10.3174C11.1971 10.52 11.0833 10.7952 11.0833 11.0833V16.9138L8.91667 17.9972V11.0833C8.91667 10.7952 8.80292 10.52 8.59925 10.3174L2.41667 4.13917V2.41667H17.5844L17.5866 4.13158L11.4008 10.3174Z",
    fill: "#2E3A59"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.86442f99f67806a0f3e0ae56de447d92.svg";
export { ForwardRef as ReactComponent };